import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { OverlayTrigger, Glyphicon, Popover } from 'react-bootstrap';


const propTypes = exact({
  unreviewReasons: PropTypes.array.isRequired,
});


const UnreviewReasonPopover = (props) => {
  const { unreviewReasons } = props;

  const unreviewedMessages = unreviewReasons.map((reason) => {
    return <p key={reason.id}>{`${reason.unreviewed_by.fullname}: ${reason.reason}`}</p>;
  });
  const popover = (
    // ID set for accessablity reasons
    <Popover id="unreview-reasons-popover">
      {unreviewedMessages}
    </Popover>
  );

  return (
    <OverlayTrigger overlay={popover}>
      <Glyphicon className="text-danger" glyph="alert" />
    </OverlayTrigger>
  );
};


UnreviewReasonPopover.propTypes = propTypes;


export default UnreviewReasonPopover;
